import { useParams } from 'react-router-dom';
import { ProtectedComponent } from '@components/protected-component';
import {
  ENABLED_PROCESS_IMPORT_CSV_ROUTE,
  ENABLED_PROCESS_IMPORT_INVITATION_ROUTE,
  ENABLED_PROCESS_IMPORT_OFFLINE_SALE_ROUTE,
  ENABLED_PROCESS_IMPORT_PASS_HOLDER_ROUTE,
} from '@constants/company-auth-permissions';
import {
  IMPORT_TYPE_CSV,
  IMPORT_TYPE_INVITATION,
  IMPORT_TYPE_OFFLINE_SALE,
  IMPORT_TYPE_PASS_HOLDER,
} from '@constants/import-process';
import ImportProcess from '@pages/events/[companyId]/[clubSlug]/import-process';

export const ProtectedImportProcess = () => {
  const { importType } = useParams<{ importType: string }>();

  let permission;
  switch (importType) {
    case IMPORT_TYPE_CSV:
      permission = ENABLED_PROCESS_IMPORT_CSV_ROUTE;
      break;
    case IMPORT_TYPE_INVITATION:
      permission = ENABLED_PROCESS_IMPORT_INVITATION_ROUTE;
      break;
    case IMPORT_TYPE_OFFLINE_SALE:
      permission = ENABLED_PROCESS_IMPORT_OFFLINE_SALE_ROUTE;
      break;
    case IMPORT_TYPE_PASS_HOLDER:
      permission = ENABLED_PROCESS_IMPORT_PASS_HOLDER_ROUTE;
      break;
    default:
      permission = [''];
  }

  return (
    <ProtectedComponent permissions={permission} isRoute>
      <ImportProcess />
    </ProtectedComponent>
  );
};
